/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
export class ScrollingService {
/**
 * @param {?} _document
 */
constructor(
private _document: any) {}
/**
 * @return {?}
 */
stopScrolling(): void {
        this._document.body.classList.add("no-scrolling");
    }
/**
 * @return {?}
 */
resumeScrolling(): void {
        if (this._document.body.classList.contains("no-scrolling")) {
            this._document.body.classList.remove("no-scrolling");
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [DOCUMENT, ] }, ]},
];
}

function ScrollingService_tsickle_Closure_declarations() {
/** @type {?} */
ScrollingService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ScrollingService.ctorParameters;
/** @type {?} */
ScrollingService.prototype._document;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
